import React, { Fragment, useEffect, useState, useContext } from "react";
import { Link, withRouter } from "react-router-dom";
import styled, { css } from "styled-components";
import { MetaContext } from "../context";
import "./quiz.css";
import {
    PopClose,
    Line,
    Flex,
    Button,
    MIcon,
    Hr,
    Preloader0,
    Preloader,
    MobHideSpan
} from './Uikit';
import { StackName } from './StackName';
import { codeHashToCopy } from './Utilities';
import { useToasts } from "react-toast-notifications";
import { StackExpanded } from './StackExpanded';
import CustomScroll from 'react-custom-scroll';
import { Scrollbars } from 'react-custom-scrollbars';

function Stack0inner({ active, history, children }) {

  const context = useContext(MetaContext);
  const [shown1, setShown1] = useState();
  const [shown2, setShown2] = useState();
  const [shown3, setShown3] = useState();
  const [checkout, setCheckout] = useState(false);


  useEffect(() => {
    if (typeof shown1 !== "undefined" && shown1 === false) {
      setTimeout(() => {
        history.push("/");
      }, 500);
    }
  }, [shown1, shown2]);


  useEffect(() => {
    if (!shown1) {
      setTimeout(() => {
        setShown1(true);
        console.log('shown1 = ', shown1);
      }, 10);
    }
    if (!shown2) {
      setTimeout(() => {
        setShown2(true);
      }, 500);
    }
    if (!shown3) {
      setTimeout(() => {
        setShown3(true);
      }, 600);
    }
  }, []);

  const handleCheckout = () => {
    setCheckout(true)
  }

  const { addToast } = useToasts();

  const renderThumb = ({ style, ...props }) => {
    const thumbStyle = {
      borderRadius: 6,
      backgroundColor: 'rgba(35, 49, 86, 0.8)'
    };
    return <div style={{ ...style, ...thumbStyle }} {...props} />;
  };

  const CustomScrollbars = props => (
    <Scrollbars
      renderThumbHorizontal={renderThumb}
      renderThumbVertical={renderThumb}
      {...props}
    />
  );

  return (<>
     <CSSpop0 active={true}>
       <div
        // className={`s0 ${shown1 ? 'active' : ''}`}
        className={`s0 active`}
        >

      <div className="cb">

      {checkout && <CSSprel0>
        <Line>
          <Preloader width={80} height={80}/>
        </Line>
        <Line>
          Please wait...
        </Line>
      </CSSprel0>}

        <div style={{background: 'white'}} className={`s_bg ${shown1 ? 'active1' : ''} ${shown2 ? 'active2' : ''} ${checkout ? 'checkout' : ''}`} />



        <div className={`s_inner ${shown3 && !checkout ? 'active' : ''}`}>
          <div className="q_top">

            <Line xs>
                <Line xs>


                  <CSSstackheader middle>


                  {Boolean(context.handles.getStack().length) && <>
                    <CSSstackheader left>
                      <StackName
                        title={context.handles.getStack("title")}

                        copyHandler={() => {
                          navigator.clipboard.writeText(
                            `https://meta-nutrition.netlify.app/import${codeHashToCopy(
                              history.location["hash"]
                            )}`
                          );
                          addToast("Stack link copied to clipboard", {
                            appearance: "success",
                            autoDismiss: true,
                            autoDismissTimeout: 1000,
                          });
                        }}

                        closeHandler={() => {
                          setShown1(false);
                          setShown2(false);
                          setShown3(false);
                          setCheckout(false);
                        }}

                        deleteHandler={()=> {
                          context.handles.deleteStack();
                          setTimeout(() => {
                            history.push(`/`);
                          }, 100);
                        }}

                      ></StackName>
                      &nbsp;&nbsp;
                    </CSSstackheader>
                    </>}

                    <Flex>








                    </Flex>
                  </CSSstackheader>
                </Line>

              </Line>


          </div>


          <div className="s_c" style={{
            // height: 'auto',
            flex:1, minHeight: 0, minWidth: 0,
            overflow: 'unset'
            }}>
          {/* <CustomScroll autoHide autoHideTimeout={500} autoHideDuration={200}> */}
            <StackExpanded stackMode={true} handleCheckout={handleCheckout}/>
          {/* </CustomScroll> */}
          </div>
          <div className="q_f" />
        </div>

      </div>
      <div className={`qz ${shown1 ? 'active' : ''}`} />
      </div>
    </CSSpop0>
    </>
  );
}


const CSSstackheader = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 991px) {
    display: block;
  }
`;

const CSSpop0 = styled.div`
  /* z-index: ${({active}) => active ? 10000 : -2 };
  opacity: ${({active}) => active ? 1 : 0 }; */
  z-index: 1000;
  opacity: 1;
  position: fixed;
  top:0;
  left: 0;
  right: 0;
  bottom: 0;
`

const CSSprel0 = styled.div`
  /* z-index: ${({active}) => active ? 10000 : -2 };
  opacity: ${({active}) => active ? 1 : 0 }; */
  z-index: 1000;
  opacity: 1;
  position: absolute;
  top:0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`


export const Stack0 = withRouter(Stack0inner);
